var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-wrapper auth-page"},[_c('div',{staticClass:"auth-card"},[_vm._t("card")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }